import $ from 'jquery';

$(function () {
    $(document).on('click', '.js-href-v1', function(e) {
        if ($(e.currentTarget).attr('data-href')) {
            window.location.href = $(e.currentTarget).attr('data-href'); 
        }
        return true;
    })
});